import fetchIntercept from 'fetch-intercept';
import Cookies from 'js-cookie';
const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;

const EXCLUDED_DOMAINS = [
  'atlas.microsoft.com',
  'zoominfo.com',
  'zi-scripts.com'
];

export const AuthInterceptor = () => {
  fetchIntercept.register({
    request: function (url, config) {
      const requestUrl = typeof url === 'string' ? url : url.url;

       if (EXCLUDED_DOMAINS.some(domain => requestUrl?.includes(domain))) {
        return [url, config];
      }

      config = config || {};
      config.headers = config.headers || {};
      const accessToken = Cookies.get("idToken") ? Cookies.get("idToken") : "";
      const microsoftGraphToken = Cookies.get("msGraphToken") ? Cookies.get("msGraphToken") : "";
      config.headers['Authorization'] = `${accessToken}`;
      if (microsoftGraphToken) {
        config.headers['X-Id-Token'] = `${microsoftGraphToken}`;
      }
      config.headers['x-functions-key'] = `${hostHeader}`;
      return [url, config];
    },

    requestError: function (error) {
      return Promise.reject(error);
    },
  });
};

